/**
 * Acesso tipado ao Leaflet.
 *
 * O Leaflet **não é empacotado** por nós: vive em `assets/vendor/leaflet/leaflet.js`
 * (1.9.4), registado em `Inc/Enqueues/EnqueueScripts.php` como `leaflet-js` e pedido
 * pelo `EclipseIberico2026::loadExtra()`. Fica em ficheiro próprio de propósito — tem
 * cache independente do nosso bundle e o `leaflet.css` precisa de conservar os
 * caminhos relativos para `vendor/leaflet/images/`.
 *
 * `import type` é apagado na compilação (nunca gera um `require`), pelo que os tipos
 * de `@types/leaflet` são usados sem que o pacote npm entre no bundle. O `L` global
 * é declarado — não importado.
 */

import type * as Leaflet from 'leaflet';

declare const L: typeof Leaflet;

export type LeafletStatic = typeof Leaflet;

/** Devolve null em vez de atirar: se o vendor falhar a carregar, o interactivo
 *  mostra a mensagem de erro normal em vez de rebentar a página do artigo. */
export function getLeaflet(): LeafletStatic | null {
    return typeof L === 'undefined' ? null : L;
}
